

































































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import FormAuthorization from "@/mixins/FormAuthorization";
import moment from "moment";
import SkriningGiziLanjutService from "@/services/SkriningGiziLanjut";
import CardSkriningGiziLanjut from "@/components/pemeriksaan/assesmen/skrininggizi/CardSkriningGiziLanjut.vue";

@Component({
  components: {
    CardSkriningGiziLanjut
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class SkriningGiziLanjutPage extends Mixins(FormAuthorization) {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    { text: "Tanggal", value: "examined_at" },
    { text: "BB (kg)", value: "berat_badan", sortable: false },
    { text: "TB (cm)", value: "tinggi_badan", sortable: false },
    { text: "IMT", value: "imt", sortable: false },
    { text: "Total Skor", value: "total_skor", sortable: false },
    { text: "Kategori", value: "kategori_risiko", sortable: false },
    { text: "Ahli Gizi", value: "ahli_gizi", sortable: false },
    { text: "Aksi", value: "actions", sortable: false }
  ];

  sortBy = "examined_at";
  sortDesc = true;
  loadingList = false;
  editItem = null;
  listData = [];
  expanded = [];

  options = {
    page: 1,
    itemsPerPage: 5,
    sortBy: [this.sortBy],
    sortDesc: [this.sortDesc]
  };

  pagination = {
    total: 0,
    current_page: 1,
    per_page: 5,
    last_page: 1,
    from: 0,
    to: 0
  };

  mounted() {
    this.getByRegister();
  }

  @Watch("options", { deep: true })
  changeOptions() {
    this.getByRegister();
  }

  getByRegister() {
    this.loadingList = true;

    const { page, itemsPerPage, sortBy, sortDesc } = this.options;

    SkriningGiziLanjutService.getByRegister(this.register, {
      page: page,
      per_page: itemsPerPage,
      sort_by: sortBy[0],
      sort_desc: sortDesc[0]
    })
      .then(resp => {
        if (resp.data) {
          this.listData = resp.data;
          this.pagination = {
            total: resp.total,
            current_page: resp.current_page,
            per_page: resp.per_page,
            last_page: resp.last_page,
            from: resp.from,
            to: resp.to
          };
        }
      })
      .finally(() => {
        this.loadingList = false;
      });
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : "-";
  }

  getKategoriColor(kategori) {
    if (kategori === "rendah") return "green";
    if (kategori === "menengah") return "orange";
    if (kategori === "tinggi") return "red";
    return "grey";
  }

  parseKategori(kategori) {
    if (kategori === "rendah") return "Risiko Rendah";
    if (kategori === "menengah") return "Risiko Menengah";
    if (kategori === "tinggi") return "Risiko Tinggi";
    return "-";
  }

  edit(item) {
    if (this.validateUserEdit(item.ahli_gizi_user_id)) {
      this.editItem = JSON.parse(JSON.stringify(item));
    }
  }

  remove(item) {
    if (
      this.validateUserEdit(item.ahli_gizi_user_id) &&
      confirmRemove("Skrining Gizi Lanjut")
    ) {
      item.deleting = true;

      SkriningGiziLanjutService.destroy(item.id)
        .then(resp => {
          if (resp && resp.status == 1) {
            appModule.NoticeDelay("Berhasil menghapus Skrining Gizi Lanjut");
          }
        })
        .finally(() => {
          item.deleting = false;
          this.editItem = null;
          this.getByRegister();
        });
    }
  }

  printPdf(id) {
    SkriningGiziLanjutService.print(id);
  }
}
